import { TimelineBars } from '../components/Charts';
import { Icon } from '../icons';
import { formatDate } from '../utils';
import { StatusDot } from '../components/Status';

export function Timeline({ data, onSelect }) {
  const groups = new Map();
  data.rollouts.forEach((rollout) => {
    const month = rollout.updatedAt.slice(0, 7);
    if (!groups.has(month)) groups.set(month, []);
    groups.get(month).push(rollout);
  });
  return (
    <main className="timeline page-view">
      <header className="page-heading"><p>Timeline</p><h1>Your memory, in motion.</h1><span>Every rollout summary ordered by the moment its evidence changed.</span></header>
      <TimelineBars points={data.pulse} />
      <div className="timeline-stream">
        {[...groups.entries()].map(([month, rollouts]) => (
          <section key={month}>
            <header><time>{new Intl.DateTimeFormat('en', { month: 'long', year: 'numeric' }).format(new Date(`${month}-01T00:00:00Z`))}</time><span>{rollouts.length} rollouts</span></header>
            <div>{rollouts.map((rollout) => (
              <button key={rollout.id} onClick={() => onSelect({ ...rollout, kind: 'rollout' })}>
                <span className="timeline-node"><i /></span>
                <span className="timeline-date">{formatDate(rollout.updatedAt, { year: false })}</span>
                <span className="timeline-copy"><strong>{rollout.title}</strong><small>{rollout.project}</small><p>{rollout.context}</p></span>
                <StatusDot status={rollout.status}/><Icon name="chevron" size={15}/>
              </button>
            ))}</div>
          </section>
        ))}
      </div>
    </main>
  );
}
